import analytics, { Events } from 'modules/Analytics';
import { getSearchAnalyticsData } from 'modules/Analytics/legacyHelpers';

export const getAnalyticsData = ({ searchFilter }) => {
  let name = `${searchFilter}s`;
  if (searchFilter === 'station') name = 'live_stations';
  if (searchFilter === 'track') name = 'songs';

  return {
    filterName: searchFilter ? name : undefined,
    filterType: searchFilter ? 'stream_type' : undefined,
    pageName: `search${searchFilter ? '_filtered' : ''}`,
  };
};

export const setTrackingDataHandler = component => {
  return data => {
    component.setState(data, () => {
      component.props.close();
    });
  };
};

export const trackSearchEventHandler = component => {
  return () => {
    const { asset, exitType, title, topHit, queryId, selected } =
      component.state;
    const {
      profileId,
      searchFilter,
      searchQuery: userSearchTerm,
      setSearchQueryId,
    } = component.props;

    if (queryId && asset?.url) setSearchQueryId(queryId, asset?.url);

    analytics.track(
      Events.Search,
      getSearchAnalyticsData({
        asset,
        exitType,
        profileId,
        selected,
        searchFilter,
        title,
        topHit,
        userSearchTerm,
        queryId,
      }),
    );
  };
};
